/**
 * Created by liuyong on 2021/4/12
 */
import request from '@/utils/request'
const baseUrl = '/api'
const timeStamp = new Date().getTime()

export default {
  // 查看活动页面
  getActInfo(data) {
    return request({
      url: `${baseUrl}/activity/message/KMGZOGAV?time=${timeStamp}`,
      method: 'get',
      params: data
    })
  },
  // 中国银行app登录
  getBocLoginCoupon(data) {
    return request({
      url: `${baseUrl}/boc/login/coupon_activity?time=${timeStamp}`,
      method: 'post',
      data
    })
  },
  // 验证手机号
  phoneVerify(data) {
    return request({
      url: `${baseUrl}/phone/verify?time=${timeStamp}`,
      method: 'post',
      data
    })
  },
  // 获取验证码
  getPhoneCode(data) {
    return request({
      url: `${baseUrl}/get/phone/code?time=${timeStamp}`,
      method: 'post',
      data
    })
  },
  // 获取京东一卡验证码
  getValidateCode(data) {
    return request({
      url: `${baseUrl}/validate/goods/send`,
      method: 'get',
      params: data
    })
  },
  // 验证京东一卡验证码
  validateCode(data) {
    return request({
      url: `${baseUrl}/validate/goods/code`,
      method: 'get',
      params: data
    })
  },
  // 手机号登录
  phoneLogin(data) {
    return request({
      url: `${baseUrl}/phone/login?time=${timeStamp}`,
      method: 'post',
      data
    })
  },
  // 微信登录
  wxLogin(data) {
    return request({
      url: `${baseUrl}/wx/login?time=${timeStamp}`,
      method: 'post',
      data
    })
  },
  // 商品详情
  getGoodsDetails(data) {
    return request({
      url: `${baseUrl}/get/goods/details?time=${timeStamp}`,
      method: 'get',
      params: data
    })
  },
  // 补全手机号
  updatePhone(data) {
    return request({
      url: `${baseUrl}/update/phone?time=${timeStamp}`,
      method: 'post',
      data
    })
  },
  // 微信分享
  shareActivity(data) {
    return request({
      url: `${baseUrl}/share/activity?time=${timeStamp}`,
      method: 'get',
      params: data
    })
  },
  // 查看用户信息
  getUserInfo(data) {
    return request({
      url: `${baseUrl}/user/info?time=${timeStamp}`,
      method: 'get',
      params: data
    })
  },
  // 用户绑定手机号并登录
  voltePhoneLogin(data) {
    return request({
      url: `${baseUrl}/phone/login?time=${timeStamp}`,
      method: 'post',
      data
    })
  },
  // 查看活动页面
  getActivityInfo(data) {
    return request({
      url: `${baseUrl}/activity/info?time=${timeStamp}`,
      method: 'get',
      params: data
    })
  },
  // 获取商家配置
  getMerchantServer(data) {
    return request({
      url: `${baseUrl}/merchant/server?time=${timeStamp}`,
      method: 'get',
      params: data
    })
  }
}
